import {
  Table,
  TableContainer,
  TRLine,
} from "./styles";

export function MainTable({ stats, style }) {
  const doingTasks = stats.doing;
  const doneTasks = stats.done;

  const doingOptions = {
    doingLen: doingTasks.filter((item) => item.moment.currentStatus === "doing")
      .length,
    lateLen: doingTasks.filter((item) => item.moment.currentStatus === "late")
      .length,
    timeAccum: doingTasks.reduce(
      (acc, item) => acc + item.expiration.number,
      0,
    ),
  };
  const doneOptions = {
    doneLen: doneTasks.filter((item) => item.moment.currentStatus === "done")
      .length,
    doneLateLen: doneTasks.filter(
      (item) => item.moment.currentStatus === "doneLate",
    ).length,
  };
  return (
    <TableContainer style={style}>
      <Table>
        <thead className="table-head">
          <tr className="first-line">
            <th>EXECUÇÃO</th>
            <th>ATRASADAS</th>
            <th>CONCLUÍDAS</th>
            <th>C. ATRASO</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <TRLine>
            <td>{doingOptions.doingLen}</td>
            <td>{doingOptions.lateLen}</td>
            <td>{doneOptions.doneLen}</td>
            <td>{doneOptions.doneLateLen}</td>
            <td>{doingTasks.length + doneTasks.length}</td>
          </TRLine>
        </tbody>
      </Table>
    </TableContainer>
  );
}
